import { Link } from "react-router-dom";

const channels = [
  { label: "娱乐资讯", to: "/news" },
  { label: "趣味原创", to: "/original" },
  { label: "视频专区", to: "/video" },
  { label: "互动社区", to: "/community" },
  { label: "关于我们", to: "/about" },
];

const friends = [
  { label: "娱乐前线", to: "/news" },
  { label: "光影档案", to: "/news" },
  { label: "手作日常", to: "/original" },
  { label: "现场笔记", to: "/video" },
];

export default function SiteFooter() {
  return (
    <footer className="mt-16 border-t border-primary-100 bg-primary-50/70">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-8 px-4 py-12 md:grid-cols-2 md:px-6 lg:grid-cols-4 lg:py-16">
        <div className="lg:col-span-1">
          <div className="flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50 dark:text-foreground-950">
              <i className="ri-emotion-happy-line text-xl"></i>
            </span>
            <span className="font-brand text-2xl leading-none text-primary-600">我爱搞</span>
          </div>
          <p className="mt-4 max-w-xs text-sm leading-relaxed text-foreground-600">
            综合娱乐资讯与原创内容平台，汇集热点娱乐新闻、原创趣味内容、多元视频与互动社区，让每一次浏览都轻松愉快。
          </p>
          <div className="mt-5 flex items-center gap-2">
            {["ri-wechat-2-line", "ri-weibo-line", "ri-bilibili-line", "ri-youtube-line"].map((icon) => (
              <button
                key={icon}
                type="button"
                aria-label="社交账号"
                className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md border border-primary-200 bg-background-50 text-foreground-600 transition-colors hover:border-primary-400 hover:text-primary-600"
              >
                <i className={`${icon} text-lg`}></i>
              </button>
            ))}
          </div>
        </div>

        <div>
          <h3 className="font-heading text-sm font-bold text-foreground-950">频道导航</h3>
          <ul className="mt-4 space-y-2.5">
            {channels.map((item) => (
              <li key={item.to}>
                <Link
                  to={item.to}
                  className="cursor-pointer text-sm text-foreground-600 transition-colors hover:text-primary-600"
                >
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="font-heading text-sm font-bold text-foreground-950">友情链接</h3>
          <ul className="mt-4 space-y-2.5">
            {friends.map((item) => (
              <li key={item.label}>
                <Link
                  to={item.to}
                  className="cursor-pointer text-sm text-foreground-600 transition-colors hover:text-primary-600"
                >
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="font-heading text-sm font-bold text-foreground-950">联系我们</h3>
          <ul className="mt-4 space-y-2.5 text-sm text-foreground-600">
            <li className="flex items-center gap-2">
              <span className="flex h-5 w-5 items-center justify-center text-primary-500">
                <i className="ri-mail-line text-base"></i>
              </span>
              hello@woaigao.com
            </li>
            <li className="flex items-center gap-2">
              <span className="flex h-5 w-5 items-center justify-center text-primary-500">
                <i className="ri-phone-line text-base"></i>
              </span>
              400-888-0000（工作日 9:00-18:00）
            </li>
            <li className="flex items-center gap-2">
              <span className="flex h-5 w-5 items-center justify-center text-primary-500">
                <i className="ri-map-pin-line text-base"></i>
              </span>
              城市文创园 A 座 12 层
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-primary-100">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-3 px-4 py-6 text-xs text-foreground-500 sm:flex-row md:px-6">
          <p>© 2026 我爱搞 woaigao.com 保留所有权利 · 本站内容为演示数据，仅供体验浏览</p>
          <div className="flex items-center gap-4">
            <Link to="/about" className="cursor-pointer transition-colors hover:text-primary-600">
              版权声明
            </Link>
            <Link to="/about" className="cursor-pointer transition-colors hover:text-primary-600">
              使用条款
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}